module.exports = __webpack_public_path__ + "img/21-3.4e32e1f0.png";